import type { ArticleCategory, Article } from '../data/mockData'

interface CategoryRule {
  groupKeys: string[]
  keywords: string[]
}

const CATEGORY_RULES: CategoryRule[] = [
  {
    groupKeys: ['gemüse', 'vegetable', 'salat', 'kräuter', 'kraeuter'],
    keywords: [
      'zwiebel', 'knoblauch', 'tomate', 'karotte', 'möhre', 'kartoffel', 'paprika',
      'gurke', 'zucchini', 'brokkoli', 'broccoli', 'blumenkohl', 'spinat', 'pilz',
      'champignon', 'lauch', 'porree', 'sellerie', 'salat', 'rucola', 'feldsalat',
      'eisberg', 'kopfsalat', 'erbse', 'bohne', 'kürbis', 'kuerbis', 'spargel',
      'aubergine', 'ingwer', 'chili', 'peperoni', 'jalapeno', 'kohl', 'wirsing',
      'rotkohl', 'weißkohl', 'blaukraut', 'sauerkraut', 'rettich', 'radieschen',
      'fenchel', 'artischocke', 'rote bete', 'pastinake', 'süßkartoffel', 'suesskartoffel',
      'petersilie', 'basilikum', 'koriander', 'schnittlauch', 'rosmarin', 'thymian',
      'dill', 'minze', 'oregano', 'salbei', 'majoran', 'kerbel', 'estragon', 'liebstöckel',
      'kresse', 'sojasprossen', 'bambussprossen', 'avocado', 'schalotte', 'romana', 'lauchzwiebel',
      'frühlingszwiebel', 'fruehlingszwiebel', 'mais', 'zuckerschoten', 'stangensellerie',
      'knollensellerie', 'mangold', 'pak choi', 'grünkohl', 'gruenkohl', 'rosenkohl', 'spitzkohl'
    ]
  },
  {
    groupKeys: ['obst', 'frucht', 'früchte', 'fruechte', 'fruit'],
    keywords: [
      'apfel', 'äpfel', 'aepfel', 'birne', 'banane', 'zitrone', 'limette', 'orange', 'mandarine',
      'clementine', 'grapefruit', 'beere', 'erdbeere', 'himbeere', 'heidelbeere',
      'blaubeere', 'brombeere', 'johannisbeere', 'stachelbeere', 'cranberry',
      'kirsche', 'traube', 'weintraube', 'pfirsich', 'nektarine', 'pflaume',
      'zwetschge', 'aprikose', 'mango', 'ananas', 'melone', 'wassermelone',
      'honigmelone', 'kiwi', 'feige', 'dattel', 'granatapfel', 'papaya',
      'maracuja', 'passionsfrucht', 'physalis', 'litschi', 'rhabarber',
      'kumquat', 'kaki', 'sharon', 'stachelbeeren', 'kokosnuss', 'holunder'
    ]
  },
  {
    groupKeys: ['fleisch', 'wurst', 'meat', 'geflügel', 'gefluegel'],
    keywords: [
      'fleisch', 'hack', 'hackfleisch', 'gehacktes', 'rind', 'rinder', 'schwein',
      'schweine', 'hähnchen', 'haehnchen', 'huhn', 'hühner', 'poulet', 'geflügel',
      'pute', 'puten', 'truthahn', 'kalb', 'kalbs', 'lamm', 'speck', 'schinken',
      'wurst', 'würstchen', 'wuerstchen', 'salami', 'wiener', 'bratwurst', 'chorizo',
      'bacon', 'steak', 'filet', 'schnitzel', 'gulasch', 'geschnetzeltes', 'kotelett',
      'entrecote', 'rippchen', 'ribs', 'leber', 'ente', 'gans', 'wild', 'currywurst',
      'bockwurst', 'weisswurst', 'weißwurst', 'fleischwurst', 'mortadella', 'lyoner',
      'leberwurst', 'teewurst', 'blutwurst', 'leberkäse', 'leberkaese', 'kassler',
      'schweinebraten', 'rinderbraten', 'roastbeef', 'mett', 'mettwurst', 'landjaeger'
    ]
  },
  {
    groupKeys: ['fisch', 'fish', 'meeresfrüchte', 'seafood'],
    keywords: [
      'fisch', 'lachs', 'salmon', 'forelle', 'thunfisch', 'tuna', 'kabeljau', 'dorsch',
      'dorade', 'scholle', 'seelachs', 'heilbutt', 'zander', 'barsch', 'hering',
      'makrele', 'sardine', 'sardelle', 'anchovis', 'garnele', 'garnelen', 'shrimp',
      'prawn', 'scampi', 'krabbe', 'krebs', 'hummer', 'muschel', 'miesmuschel',
      'tintenfisch', 'calamari', 'oktopus', 'pulpo', 'surimi', 'matjes', 'bismarckhering',
      'räucherlachs', 'raeucherlachs', 'fischstäbchen', 'fischstaebchen', 'schlemmerfilet'
    ]
  },
  {
    groupKeys: ['lebensmittel', 'groceries', 'teigwaren', 'konserven', 'vorrat'],
    keywords: [
      'nudel', 'pasta', 'spaghetti', 'penne', 'fusilli', 'tagliatelle', 'rigatoni', 'farfalle',
      'lasagne', 'tortellini', 'gnocchi', 'spätzle', 'spaetzle', 'reis', 'basmati',
      'jasminreis', 'milchreis', 'risotto', 'couscous', 'bulgur', 'quinoa', 'polenta',
      'grieß', 'griess', 'haferflocken', 'müsli', 'muesli', 'cornflakes', 'granola', 'linse',
      'kichererbse', 'kidneybohnen', 'tomatenmark', 'passierte tomaten',
      'gehackte tomaten', 'kokosmilch', 'pesto', 'ajvar', 'nudelsauce', 'tomatensauce',
      'nuss', 'nüsse', 'nuesse', 'walnuss', 'walnüsse', 'walnuesse', 'haselnuss',
      'haselnüsse', 'haselnuesse', 'mandel', 'mandeln', 'cashew', 'cashews',
      'erdnuss', 'erdnüsse', 'erdnuesse', 'pinienkerne', 'pistazie', 'pistazien',
      'sonnenblumenkerne', 'kürbiskerne', 'kuerbiskerne', 'sesam', 'chia', 'chiasamen',
      'leinsamen', 'zucker', 'rohrzucker', 'brauner zucker', 'puderzucker', 'honig',
      'ahornsirup', 'agavendicksaft', 'senf', 'ketchup', 'mayonnaise', 'mayo',
      'apfelmus', 'marmelade', 'konfitüre', 'konfituere', 'nutella'
    ]
  },
  {
    groupKeys: ['molkerei', 'milch', 'dairy', 'käse', 'kaese'],
    keywords: [
      'milch', 'butter', 'sahne', 'schlagsahne', 'kochsahne', 'schmand',
      'sauerrahm', 'crème fraîche', 'creme fraiche', 'cremefraiche', 'quark',
      'magerquark', 'joghurt', 'frischkäse', 'frischkaese', 'mascarpone', 'ricotta', 'käse', 'kaese',
      'parmesan', 'grana padano', 'pecorino', 'gouda', 'emmentaler', 'mozzarella',
      'burrata', 'feta', 'schafskäse', 'schafskaese', 'ziegenkäse', 'ziegenkaese',
      'cheddar', 'camembert', 'brie', 'gorgonzola', 'buttermilch', 'kondensmilch',
      'kefir', 'eier', 'eigelb', 'eiweiß', 'skyr', 'ayran', 'schmelzkäse', 'reibekäse', 'reibekaese',
      'hafermilch', 'sojamilch', 'mandelmilch', 'margarine', 'rama', 'becel'
    ]
  },
  {
    groupKeys: ['gewürz', 'gewuerz', 'spice', 'spices', 'öl', 'oel', 'oil', 'essig'],
    keywords: [
      'gewürz', 'gewuerz', 'gewürze', 'gewuerze',
      'salz', 'pfeffer', 'paprikapulver', 'curry', 'currypulver', 'muskat', 'muskatnuss',
      'zimt', 'nelke', 'nelken', 'kümmel', 'kuemmel', 'kreuzkümmel', 'kumin', 'cumin',
      'kurkuma', 'kardamom', 'piment', 'lorbeer', 'lorbeerblatt', 'lorbeerblätter',
      'brühe', 'bruehe', 'gemüsebrühe', 'rinderbrühe', 'hühnerbrühe', 'fleischbrühe',
      'fond', 'bouillon', 'sojasauce', 'sojasoße', 'worcester', 'tabasco', 'sambal',
      'sriracha', 'olivenöl', 'olivenoel', 'rapsöl', 'rapsoel', 'sonnenblumenöl',
      'sesamöl', 'kokosöl', 'leinöl', 'speiseöl', 'pflanzenöl', 'essig', 'balsamico'
    ]
  },
  {
    groupKeys: ['backzutaten', 'backen', 'baking'],
    keywords: [
      'mehl', 'weizenmehl', 'dinkelmehl', 'speisestärke', 'stärke', 'backpulver',
      'natron', 'hefe', 'trockenhefe', 'puderzucker', 'kakao', 'kakaopulver',
      'vanillezucker', 'vanilleschote', 'vanillearoma', 'backaroma', 'kuvertüre',
      'schokostreusel', 'rosinen', 'gelatine', 'agar agar', 'tortenguss'
    ]
  },
  {
    groupKeys: ['back', 'baking', 'bäckerei', 'baeckerei', 'brot', 'bread'],
    keywords: [
      'brot', 'brötchen', 'broetchen', 'baguette', 'toast', 'fladenbrot', 'ciabatta',
      'pita', 'pumpernickel', 'brezel', 'croissant', 'tortilla', 'wrap', 'semmel',
      'schrippe', 'kuchen', 'torte', 'muffin', 'donut', 'krapfen', 'berliner',
      'streuselkuchen', 'apfelkuchen', 'käsekuchen', 'kaesekuchen', 'marmorkuchen'
    ]
  },
  {
    groupKeys: ['getränk', 'getraenk', 'drink', 'beverage'],
    keywords: [
      'wasser', 'mineralwasser', 'sprudelwasser', 'stilles wasser', 'saft', 'apfelsaft',
      'orangensaft', 'multivitaminsaft', 'kirschsaft', 'traubensaft', 'schorle', 'apfelschorle',
      'wein', 'rotwein', 'weißwein', 'weisswein', 'rosewein', 'glühwein', 'gluehwein',
      'bier', 'pils', 'weizen', 'radler', 'sekt', 'prosecco', 'champagner', 'rum', 'schnaps',
      'whisky', 'whiskey', 'vodka', 'wodka', 'gin', 'likör', 'likoer', 'amaretto', 'aperol',
      'kaffee', 'espresso', 'cappuccino', 'latte', 'milchkaffee', 'kaffeebohnen', 'tee',
      'schwarztee', 'grüntee', 'gruentee', 'kamillentee', 'pfefferminztee', 'früchtetee',
      'kräutertee', 'fencheltee', 'cola', 'coca-cola', 'coca cola', 'pepsi', 'fanta',
      'sprite', 'mezzomix', 'spezi', 'eistee', 'energy drink', 'red bull', 'bionade',
      'mate', 'limonade', 'sirup', 'tonic', 'bitter lemon'
    ]
  },
  {
    groupKeys: ['süß', 'suess', 'sweet', 'snack', 'süßigkeit', 'suessigkeit'],
    keywords: [
      'schokolade', 'vollmilch', 'zartbitter', 'pralinen', 'praline', 'kekse', 'cookies',
      'chips', 'kartoffelchips', 'salzstangen', 'erdnussflips', 'flips', 'gummibärchen',
      'gummibaerchen', 'fruchtgummi', 'bonbon', 'bonbons', 'popcorn', 'marshmallow',
      'marshmallows', 'schokoriegel', 'waffeln', 'kaugummi', 'lakritz', 'haribo',
      'toffifee', 'duplo', 'hanuta', 'knoppers', 'kinderriegel', 'kinderschokolade',
      'merci', 'mon cheri', 'rocher', 'raffaello', 'oreo', 'snickers', 'twix', 'mars'
    ]
  },
  {
    groupKeys: ['tiefkühl', 'tiefkuehl', 'frozen', 'tk'],
    keywords: [
      'eis', 'eiscreme', 'speiseeis', 'stieleis', 'magnum', 'tiefkühl', 'tiefkuehl', 'tk-',
      'pizza', 'pommes', 'pommes frites', 'kroketten', 'fischstäbchen', 'fischstaebchen',
      'schlemmerfilet', 'rahmspinat', 'tiefkühlpizza', 'tiefkuehlpizza', 'flammkuchen'
    ]
  },
  {
    groupKeys: ['drogerie', 'hygiene', 'haushalt', 'putzmittel'],
    keywords: [
      'toilettenpapier', 'klopapier', 'küchenrolle', 'kuechenrolle', 'zewa', 'taschentücher',
      'taschentuecher', 'tempo', 'seife', 'duschgel', 'shampoo', 'zahnpasta', 'zahnbürste',
      'zahnbuerste', 'zahnseide', 'deo', 'deodorant', 'spülmittel', 'spuelmittel',
      'spülmaschinentabs', 'spuelmaschinentabs', 'waschmittel', 'weichspüler', 'weichspueler',
      'müllbeutel', 'muellbeutel', 'alufolie', 'frischhaltefolie', 'backpapier',
      'schwamm', 'wattepads', 'feuchttücher', 'feuchttuecher', 'allzweckreiniger'
    ]
  }
]

function findCategoryByGroupKeys(groupKeys: string[], categories: ArticleCategory[]): ArticleCategory | undefined {
  return categories.find(c => {
    const nameLower = (c.name || '').toLowerCase()
    const idLower = (c.id || '').toLowerCase()
    return groupKeys.some(gk => nameLower.includes(gk) || idLower.includes(gk))
  })
}

export function findFallbackCategory(categories: ArticleCategory[]): string {
  if (!categories || categories.length === 0) return ''

  // 1. Sonstiges / Misc
  const misc = categories.find(c => 
    c.id === 'cat-misc' ||
    /sonstig|misc|allgemein|verschieden|andere|extra/i.test(c.name)
  )
  if (misc) return misc.id

  // 2. Lebensmittel / Vorrat / Groceries
  const groceries = categories.find(c =>
    c.id === 'cat-groceries' ||
    /lebensmittel|vorrat|grocer/i.test(c.name)
  )
  if (groceries) return groceries.id

  // 3. Last category or first category
  return categories[0]?.id || '1'
}

const SHORT_KW_REGEX_CACHE = new Map<string, RegExp>()

function getShortKeywordRegex(kw: string): RegExp {
  let regex = SHORT_KW_REGEX_CACHE.get(kw)
  if (!regex) {
    regex = new RegExp(`(^|[^a-zäöüß])${kw}([^a-zäöüß]|$)`, 'i')
    SHORT_KW_REGEX_CACHE.set(kw, regex)
  }
  return regex
}

function matchesKeyword(text: string, kw: string): boolean {
  if (kw.length <= 3) {
    return getShortKeywordRegex(kw).test(text)
  }
  return text.includes(kw)
}

const EI_REGEX = /(?:^|[^a-zäöüß])(ei|eier)(?:[^a-zäöüß]|$)/i
const OEL_REGEX = /(?:^|[^a-zäöüß])(öl|oel)(?:[^a-zäöüß]|$)/i
const GEWUERZ_REGEX = /gewürz|gewuerz/i

/**
 * Intelligently matches or predicts the best ArticleCategory ID for a given article name.
 * 1. Checks existing articles (fuzzy / token / substring match).
 * 2. Checks culinary semantic keyword rules, preferring longer/more specific keyword matches.
 * 3. Falls back to "Sonstiges" / "Lebensmittel" instead of blindly picking the first category.
 */
export function matchCategoryForArticleName(
  articleName: string,
  categories: ArticleCategory[],
  existingArticles: Article[] = []
): string {
  if (!categories || categories.length === 0) return ''

  const clean = articleName.trim().toLowerCase()
  if (!clean) {
    return findFallbackCategory(categories)
  }

  // Direct rule: If article contains "gewürz" or "gewuerz", route directly to "Gewürze" category if available
  if (GEWUERZ_REGEX.test(clean)) {
    const spiceCategory = categories.find(c => GEWUERZ_REGEX.test(c.name))
      || findCategoryByGroupKeys(['gewürz', 'gewuerz', 'spice', 'spices'], categories)
    if (spiceCategory) {
      return spiceCategory.id
    }
    return findFallbackCategory(categories)
  }

  // 1. Check existing articles for exact or strong substring or token match
  const validCategoriesSet = new Set(categories.map(c => c.id))
  const tokens = clean.split(/[\s,/-]+/).filter(t => t.length >= 3)
  for (const art of existingArticles) {
    if (!art.categoryID) continue
    const artLower = (art.name || '').toLowerCase()
    // Exact or strong substring match
    if (artLower === clean || artLower.includes(clean) || clean.includes(artLower)) {
      if (validCategoriesSet.has(art.categoryID)) {
        return art.categoryID
      }
    }
    // Token match
    const artTokens = artLower.split(/[\s,/-]+/).filter(t => t.length >= 3)
    if (tokens.some(t => artTokens.includes(t))) {
      if (validCategoriesSet.has(art.categoryID)) {
        return art.categoryID
      }
    }
  }

  // 2. Keyword & semantic mapping - collect best match by keyword length
  let bestMatch: { categoryId: string; length: number } | null = null

  for (const rule of CATEGORY_RULES) {
    const matchedCategory = findCategoryByGroupKeys(rule.groupKeys, categories)
    if (!matchedCategory) continue

    for (const kw of rule.keywords) {
      if (matchesKeyword(clean, kw)) {
        if (!bestMatch || kw.length > bestMatch.length) {
          bestMatch = { categoryId: matchedCategory.id, length: kw.length }
        }
      }
    }
  }

  if (bestMatch) {
    return bestMatch.categoryId
  }

  // Special single words like "Ei" or "Öl"
  if (EI_REGEX.test(clean)) {
    const dairy = findCategoryByGroupKeys(['molkerei', 'milch', 'dairy'], categories)
    if (dairy) return dairy.id
  }
  if (OEL_REGEX.test(clean)) {
    const spices = findCategoryByGroupKeys(['gewürz', 'gewuerz', 'spice', 'spices', 'öl', 'oel', 'oil'], categories)
    if (spices) return spices.id
  }

  // 3. Fallback
  return findFallbackCategory(categories)
}
